/**
* 如果成功获取文件，调用onGetFiles返回获取的文件，调用参数为File为元素的数组: [File]， 如
*	cavas.toBlob(blob => {
*		const file = new File([blob], `${Ext.Date.format(new Date(), 'YmdHisu')}.jpg`, { type: 'image/jpeg' })
*		onGetFiles([file])
*		onClose && onClose()
*	}, 'image/jpeg', 0.95)
* @param {*} onGetFiles 
*/
const showCordovaCamera = onGetFiles => {
	//console.log('请在这儿实现 Cordova Camera 代码')
	//Ext.toast('在devTools可找到需要实现 Cordova Camera 代码 的位置')
	navigator.camera.getPicture((bstr) => {
		//const file = dataURLToFile("data:image/jpeg;base64," + bstr, `${Ext.Date.format(new Date(), 'YmdHisu')}.jpg`)
		let blob = dataURLtoBlob("data:image/jpeg;base64," + bstr);
		const file = blobToFile(blob, `${Ext.Date.format(new Date(), 'YmdHisu')}.jpg`);
		onGetFiles([file])
	}, (error) => {
		console.debug("Unable to obtain picture: " + error, "app");
	}, setOptions())
}

function setOptions() {
	var options = {
		// Some common settings are 20, 50, and 100
		quality: 50,
		destinationType: Camera.DestinationType.DATA_URL,
		encodingType: Camera.EncodingType.JPEG,
		correctOrientation: true,
	}
	return options
}

/**
 * base64转file    
 * base64格式：data:image/png;base64,iVBORw0KGgoAAAANSU...
 * @param {*} dataURL base64编码数据
 * @param {*} filename 文件名称
 */
function dataURLToFile(dataURL, filename) {
	const arr = dataURL.split(','),
		mime = arr[0].match(/:(.*?);/)[1], //mime类型 image/png
		bstr = atob(arr[1]) //base64 解码

	let n = bstr.length,
		u8arr = new Uint8Array(n)

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n)
	}

	return new File([u8arr], filename, { type: mime })
	//return new Blob([a8arr], {type: mime});
}
function dataURLtoBlob(dataURL) {
	var arr = dataURL.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n)
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n)
	}
	return new Blob([u8arr], { type: mime })
}

function blobToFile(theBlob, fileName) {
	theBlob.lastModifiedDate = new Date()
	theBlob.name = fileName
	return theBlob
}

export default showCordovaCamera